import React, { useState } from 'react';
import styles from './Setting.module.css';

const SecuritySettings = () => {
  const [resetPasswordMode, setResetPasswordMode] = useState(false); // Toggle for reset password mode
  const [currentPassword, setCurrentPassword] = useState(''); // State for current password
  const [newPassword, setNewPassword] = useState(''); // State for new password
  const [confirmPassword, setConfirmPassword] = useState(''); // State for confirm password
  const [error, setError] = useState(''); // State for error messages

  const handleResetPassword = () => {
    // Clear previous errors
    setError('');

    // Validation checks
    if (!currentPassword) {
      setError('Current password is required');
      return;
    }
    if (!newPassword) {
      setError('New password is required');
      return;
    }
    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters long');
      return;
    }
    if (!confirmPassword) {
      setError('Please confirm your new password');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('New password and confirm password do not match');
      return;
    }

    // If all validations pass
    alert('Password reset successfully!');
    setResetPasswordMode(false); // Exit reset password mode after success
    // Clear the input fields
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const handleCancel = () => {
    // Reset all states and exit reset mode
    setResetPasswordMode(false);
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setError('');
  };

  const handleForgotPassword = () => {
    alert('Forgot Password functionality is not implemented yet.');
    // Add logic for forgot password functionality here
  };

  return (
    <div className={styles.sectionContent}>
      <h3>Security Settings</h3>
      {!resetPasswordMode ? (
        <button
          onClick={() => setResetPasswordMode(true)}
          className={styles.saveButton}
        >
          Reset Password
        </button>
      ) : (
        <>
          {/* Current Password Input */}
          <div className={styles.formGroup}>
            <label>Current Password:</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className={styles.inputField}
            />
          </div>

          {/* New Password Input */}
          <div className={styles.formGroup}>
            <label>New Password:</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className={styles.inputField}
            />
          </div>

          {/* Confirm New Password Input */}
          <div className={styles.formGroup}>
            <label>Confirm New Password:</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className={styles.inputField}
            />
          </div>

          {/* Error Message */}
          {error && <div className={styles.error}>{error}</div>}

          {/* Action Buttons */}
          <div className={styles.buttonGroup}>
            <button onClick={handleResetPassword} className={styles.saveButton}>
              Save New Password
            </button>
            <button onClick={handleCancel} className={styles.cancelButton}>
              Cancel
            </button>
          </div>
        </>
      )}

      {/* Forgot Password */}
      <div className={styles.forgotPassword}>
        <button
          onClick={handleForgotPassword}
          className={styles.forgotPasswordButton}
        >
          Forgot Password?
        </button>
      </div>
    </div>
  );
};

export default SecuritySettings;
